{
  "tabs": {
    "producers": "Produtores",
    "beefOverview": "Visão Geral de Carne",
    "comparisons": "Comparações",
    "benchMarking": "Benchmarking",
    "plantComparison": "Comparação de Plantas",
    "liveToCameraDashboard": "Live to Camera Dashboard"
  },
  "allLocations": "Todos os Locais",
  "producers": {
    "producer": "Produtor",
    "noFarmerNamesAssigned": "Você não tem nomes de produtores atribuídos para este local. Por favor, entre em contato com seu administrador para atribuir nomes de produtores à sua conta.",
    "avgWeight": "Peso Médio",
    "avgYieldGrade": "Rendimento Médio",
    "avgUsdaMarbling": "Marmoreio USDA Médio",
    "totalCarcases": "Total de Carcaças",
    "averageOverSelectedPeriod": "Média do período selecionado",
    "averageOverLast12Months": "Média dos últimos 12 meses",
    "totalCarcasesInfo": "Total de carcaças escaneadas com registros de YG, por data de escaneamento, exclui carcaças não escaneadas.",
    "producerLabel": "Produtor: {{name}}"
  },
  "filters": {
    "all": "Todos",
    "breed": "Raça",
    "sex": "Sexo",
    "city": "Cidade",
    "consignment": "Lote de Abate",
    "age": "Idade",
    "lotBatch": "Lote",
    "brand": "Marca",
    "allBrands": "Todas as Marcas",
    "all1953": "1953 Todas",
    "filters": "Filtros",
    "editConsignmentName": "Editar Nome do Lote",
    "consignmentName": "Nome do Lote",
    "update": "Atualizar",
    "clickToEditName": "Clique para editar o nome"
  },
  "beefOverview": {
    "numberOfCarcases": "Número de Carcaças",
    "numberOfCarcasses": "Número de Carcaças",
    "yieldGrade": "Grau de Rendimento",
    "usdaMarbling": "Marmoreio USDA",
    "yieldGradeDistribution": "Distribuição de Grau de Rendimento",
    "usdaMarblingDistribution": "Distribuição de Marmoreio USDA",
    "distribution": "Distribuição de {{trait}}",
    "vsChart": "{{xAxis}} vs {{yAxis}}",
    "copyBarcode": "Copiar Código de Barras",
    "carcasses": "carcaças",
    "count": "Contagem",
    "percentage": "Porcentagem",
    "traitImagesTitle": "Imagens de {{trait}}",
    "traitSelection": "{{trait}}: {{group}}"
  },
  "comparisons": {
    "producerPerformance": "Desempenho do Produtor: Grau de Rendimento vs Marmoreio",
    "producerSummary": "Resumo do Produtor",
    "yieldGradeDistributionComparison": "Comparação de Distribuição de Grau de Rendimento",
    "rank": "Classificação",
    "yieldGradeDistribution": "Distribuição de Grau de Rendimento",
    "averageMarblingScore": "Pontuação Média de Marmoreio",
    "averageSubcutFat": "Gordura Subcutânea Média",
    "averageOverallYGScore": "Pontuação Média Geral de Rendimento",
    "avgMarbling": "Marmoreio Médio",
    "avgSubcutFat": "Gordura Subcutânea Média",
    "producerName": "Nome do produtor",
    "topTen": "Top 10",
    "bottomTen": "Últimos 10",
    "clearAll": "Limpar Tudo",
    "allProducersAverage": "Média de Todos os Produtores",
    "percentageOfAnimals": "Porcentagem de Animais (%)",
    "farmerImagesTitle": "Imagens de {{name}}"
  },
  "benchmarking": {
    "keyPerformanceMetrics": "Métricas de Desempenho Chave",
    "avg": "Média",
    "usdaQualityGradeDistribution": "Distribuição de Grau de Qualidade USDA",
    "qualityGrade": "Grau de Qualidade",
    "percentageOfAnimals": "Porcentagem de Animais (%)",
    "yourData": "Seus Dados",
    "allProducers": "Todos os Produtores",
    "selectProducer": "Selecione um produtor para visualizar os dados",
    "multiMetricComparison": "Comparação Multi-Métrica",
    "percentileRanking": "Classificação Percentual",
    "yourPerformance": "Seu Desempenho",
    "top10Percent": "Top 10%",
    "distributionComparison": "Comparação de Distribuição",
    "usdaMarblingDistribution": "Distribuição de Marmoreio USDA",
    "yieldGradeDistribution": "Distribuição de Grau de Rendimento",
    "distributionPercent": "Distribuição %",
    "performanceTrends": "Tendências de Desempenho (12 Meses)",
    "usdaMarblingScoreOverTime": "Pontuação de Marmoreio USDA ao Longo do Tempo",
    "yieldGradeScoreOverTime": "Pontuação de Grau de Rendimento ao Longo do Tempo",
    "producerAverage": "Média dos Produtores",
    "marbling": "Marmoreio",
    "yieldGrade": "Grau de Rendimento",
    "hotCarcassWeight": "Peso da Carcaça Quente",
    "hotCarcassWeightDistribution": "Distribuição de Peso da Carcaça Quente",
    "hotCarcassWeightOverTime": "Peso da Carcaça Quente ao Longo do Tempo",
    "yourAnimalDemographics": "Seus Dados Demográficos de Animais",
    "byBreed": "Por Raça",
    "bySex": "Por Sexo",
    "metrics": {
      "usdaMarbling": "Marmoreio USDA",
      "yieldGrade": "Grau de Rendimento",
      "hotCarcassWeight": "Peso da Carcaça Quente",
      "ribEyeArea": "Área do Olho do Lombo",
      "backFat": "Gordura Dorsal",
      "selectPercent": "Select %",
      "primePercent": "Prime %",
      "choicePercent": "Choice %"
    },
    "vsProducerAverage": "Vs média dos produtores",
    "nthPercentile": "{{value}} percentil",
    "month": "Mês",
    "usdaMarblingScore": "Pontuação de Marmoreio USDA",
    "weightKg": "Peso (kg)",
    "selectMetric": "Selecionar métrica"
  },
  "plantComparison": {
    "title": "Comparação de Plantas",
    "allPlants": "Todas as Plantas",
    "metric": "Métrica",
    "metrics": {
      "marbling": "Marmoreio USDA",
      "yieldGrade": "Grau de Rendimento",
      "ema": "Área do Olho do Lombo (cm²)",
      "ribFat": "Gordura Dorsal (mm)",
      "weight": "Peso da Carcaça Quente (kg)"
    },
    "views": {
      "trend": "Tendência",
      "distribution": "Distribuição"
    },
    "noDataToDisplay": "Nenhum dado para exibir"
  },
  "imageGrid": {
    "title": "Grade de Imagens Marmoreio USDA × Grau de Rendimento",
    "images": "Imagens",
    "heatmap": "Mapa de Calor",
    "avgVolumePercent": "Volume Médio %",
    "avgWeight": "Peso Médio",
    "avgRibEyeArea": "Área Média do Olho do Lombo",
    "volumePercent": "Volume %",
    "noDataToDisplay": "Nenhum dado para exibir",
    "noImage": "Sem Imagem",
    "usdaMarblingGrade": "Grau de Marmoreio USDA"
  },
  "cellDetails": {
    "title": "Detalhes da Célula",
    "clickToView": "Clique em uma célula na grade de imagens para ver métricas detalhadas e análises para essa combinação de Rendimento × Marmoreio USDA.",
    "selectImage": "Selecione uma imagem à esquerda para visualizá-la aqui",
    "ygGuide": "Guia {{label}}",
    "ygGuide1": "Maior rendimento de varejo, gordura externa mínima, maior área do olho do lombo em relação ao peso da carcaça. Produz a maior porcentagem de cortes de varejo valiosos com mínima necessidade de aparamento de gordura.",
    "ygGuide2": "Alto rendimento de varejo com gordura externa moderada e boa área do olho do lombo. Produz uma alta porcentagem de cortes de varejo com mínimo aparamento de gordura necessário.",
    "ygGuide3": "Rendimento de varejo médio com gordura externa moderada e área do olho do lombo. Porcentagem padrão de cortes de varejo com aparamento de gordura moderado necessário.",
    "ygGuide4": "Rendimento de varejo abaixo da média com aumento de gordura externa e menor área do olho do lombo. Menor porcentagem de cortes de varejo com considerável aparamento de gordura necessário.",
    "ygGuide5": "Menor rendimento de varejo, maior gordura externa, menor área do olho do lombo em relação ao peso da carcaça. Aparamento significativo de gordura necessário, resultando na menor porcentagem de cortes de varejo valiosos.",
    "imagesCount": "{{count}} de {{total}} imagens",
    "overview": "Visão Geral",
    "producers": "Produtores",
    "cellMetrics": "Métricas da Célula",
    "avgRibEyeArea": "Área Média do Olho do Lombo:",
    "avgSubCutFat": "Gordura Subcutânea Média:",
    "avgHSCW": "HSCW Médio:",
    "performance": "Desempenho",
    "dailyAverage": "Média Diária:",
    "monthlyProjection": "Projeção Mensal:",
    "animal": "animal",
    "animals": "animais",
    "noProducerData": "Nenhum dado de produtor disponível",
    "topProducers": "Top 5 Produtores",
    "producerTooltip": "A porcentagem representa a proporção das {{count}} imagens {{marbling}} × {{yg}} que pertencem a cada produtor. O segundo número é a contagem para esse produtor."
  },
  "glossary": {
    "title": "Glossário",
    "averageWeight": {
      "title": "Peso Médio",
      "content": "O peso médio de carcaça quente de todos os animais processados no período selecionado. Esse valor mostra quão pesados estão os seus animais no momento do abate e permite comparações entre estações, genética e programas de alimentação."
    },
    "yieldGrade": {
      "title": "Grau de Rendimento (YG)",
      "content": "O Grau de Rendimento é um sistema dos EUA que prevê quanto carne magra, desossada e comercializável uma carcaça irá produzir. Ele varia de YG 1 a YG 5: YG 1 é muito magro com maior rendimento de carne, enquanto YG 5 tem maior cobertura de gordura e menor rendimento."
    },
    "yieldGradeCalculation": {
      "title": "Como o Grau de Rendimento é Calculado",
      "content": "O Grau de Rendimento é determinado usando quatro medições da carcaça: (1) Espessura de gordura externa sobre o contrafilé, (2) Área do contrafilé (indicador de musculatura), (3) Peso da carcaça quente, e (4) Gordura interna estimada ao redor dos rins, pelve e coração (KPH). Esses fatores são combinados para estimar a porcentagem de carne comercializável."
    },
    "yieldGradeImportance": {
      "title": "Por que o Grau de Rendimento Importa",
      "content": "O Grau de Rendimento mostra quão eficientemente o animal converte peso em carne de alto valor. Ele ajuda a identificar: se os animais estão sendo abatidos cedo demais ou tarde demais, se a cobertura de gordura está excessiva ou adequada, como genética e alimentação influenciam o rendimento magro, e oportunidades para reduzir desperdício e aumentar lucratividade."
    },
    "usdaMarbling": {
      "title": "Marmoreio USDA",
      "content": "O marmoreio USDA é uma pontuação que representa a quantidade e distribuição de gordura intramuscular dentro do contrafilé. Maior marmoreio geralmente resulta em melhor maciez, suculência e sabor. Essa pontuação define os graus de qualidade dos EUA."
    },
    "usdaQualityGrades": {
      "title": "Graus de Qualidade USDA (Prime, Choice, Low Choice, Select)",
      "content": "Essas categorias classificam a carne principalmente com base no nível de marmoreio: Prime tem marmoreio excepcional e qualidade superior; Choice é carne de alta qualidade com bom marmoreio; Low Choice é a faixa inferior de Choice, mas ainda boa qualidade; Select é mais magra, com menos marmoreio e qualidade inferior."
    },
    "usdaMarblingScore": {
      "title": "Pontuação Numérica de Marmoreio USDA",
      "content": "Um valor numérico contínuo medido pela tecnologia MEQ que indica o nível de gordura intramuscular. Pontuações maiores correspondem a categorias de maior qualidade como Prime e Choice."
    },
    "carcass": {
      "title": "Carcaça / Total de Carcaças",
      "content": "Uma carcaça é o corpo processado do animal após a evisceração e retirada da cabeça, couro e patas inferiores. \"Total de Carcaças\" indica o número de animais incluídos no período selecionado."
    },
    "volumePercent": {
      "title": "Percentual de Volume (%)",
      "content": "O percentual de carcaças que se enquadram em uma determinada categoria (como um grau de rendimento ou nível de marmoreio). Isso mostra como o rebanho está distribuído entre diferentes resultados de qualidade e rendimento."
    },
    "imageGrid": {
      "title": "Grade de Imagens (Images)",
      "content": "Uma exibição visual de fotos reais de carcaças para diferentes combinações de marmoreio e Grau de Rendimento. Essas imagens ajudam o produtor a ver claramente como cada classificação aparece na prática — cobertura de gordura, área muscular e padrões de marmoreio."
    }
  }
}
